import { estimateAudience, maxAffordableCcu } from "@woven/contracts";
import { Tooltip } from "../../components/ui/Tooltip";

export function CapacityTooltip({
  tickRateHz = 10,
  ccu = 25,
  capacity,
  label = "How capacity is calculated",
}: {
  tickRateHz?: number;
  ccu?: number;
  capacity?: number;
  label?: string;
}) {
  const exampleCcu = capacity === undefined ? ccu : maxAffordableCcu(capacity, tickRateHz);
  const audience = estimateAudience(exampleCcu);
  return (
    <Tooltip label={label}>
      {capacity === undefined ? (
        <span>Capacity = tick rate (Hz) × allocated CCU (concurrent users).</span>
      ) : null}
      {capacity !== undefined ? (
        <span>
          Capacity units (CU) are shared across your servers. Hz is the per-user publish-rate
          ceiling, not a delivery guarantee.
        </span>
      ) : null}
      <span>
        Example: {tickRateHz} Hz × {exampleCcu.toLocaleString("en-US")} CCU ={" "}
        {(tickRateHz * exampleCcu).toLocaleString("en-US")} capacity units.
      </span>

      <span>
        {exampleCcu.toLocaleString("en-US")} CCU × 20 ≈{" "}
        {audience.estimatedDau.toLocaleString("en-US")} DAU; DAU × 20 ≈{" "}
        {audience.estimatedMau.toLocaleString("en-US")} MAU.
      </span>
      <small>
        <em>* Rough average estimates; session/playtime strongly changes results</em>
      </small>
    </Tooltip>
  );
}
